import { useQuery } from '@tanstack/react-query'

import { stationApi } from '@/services/api/endpoints/stationApi'
import { queryKeys } from '@/services/api/queryKeys'

/** Источник обоих эндпоинтов обновляется раз в 5 минут, опрос чаще — чтобы «Обновлено» не отставало. */
const CURRENT_STATE_QUERY = { refetchInterval: 60_000, staleTime: 30_000 } as const

/** Состояние топливных колонок (ТЗ п. 4.2). */
export const useColumnsQuery = () =>
  useQuery({ queryKey: queryKeys.columns, queryFn: stationApi.getColumns, ...CURRENT_STATE_QUERY })

/** Статус кассиров (ТЗ п. 4.3). */
export const useCashiersQuery = () =>
  useQuery({
    queryKey: queryKeys.cashiers,
    queryFn: stationApi.getCashiers,
    ...CURRENT_STATE_QUERY,
  })
